export default __webpack_public_path__ + "static/media/btn-play.93a0f0ae.svg";